import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const LikelyToChurn = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 128 128" fill="none" {...props}>
    <path
      d="M12.8 64C12.8 77.5791 18.1943 90.602 27.7961 100.204C37.398 109.806 50.4209 115.2 64 115.2C77.5791 115.2 90.602 109.806 100.204 100.204C109.806 90.602 115.2 77.5791 115.2 64C115.2 50.4209 109.806 37.398 100.204 27.7961C90.602 18.1943 77.5791 12.8 64 12.8C50.4209 12.8 37.398 18.1943 27.7961 27.7961C18.1943 37.398 12.8 50.4209 12.8 64Z"
      fill="#EBD3F1"
    />
    <path
      d="M36.9434 70.1081L46.2054 41.6665L91.0554 56.2751L81.792 84.7155L36.9434 70.1081Z"
      fill="white"
    />
    <path
      d="M38.7878 70.5062L60.0896 61.0444"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.0679 83.9501L68.4237 63.7594"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.2765 55.369L48.9805 42.569C48.5067 42.4146 48.0014 42.3838 47.5124 42.4795C47.0234 42.5751 46.5669 42.7941 46.1862 43.1155L62.4153 64.0563C62.6839 64.4046 63.051 64.6641 63.469 64.8011C63.8869 64.938 64.3364 64.9461 64.759 64.8243L90.208 57.4579C90.0903 56.9742 89.8512 56.5284 89.5132 56.1629C89.1752 55.7973 88.7495 55.5241 88.2765 55.369Z"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.9434 70.1081L46.2054 41.6665L91.0554 56.2751L81.792 84.7155L36.9434 70.1081Z"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.104 106.788C54.5859 106.788 46.259 104.262 39.1765 99.5294C32.0939 94.797 26.5738 88.0706 23.3141 80.2008C20.0544 72.3311 19.2016 63.6715 20.8635 55.317C22.5254 46.9626 26.6274 39.2886 32.6507 33.2654C38.674 27.2423 46.3481 23.1405 54.7026 21.4789C63.0571 19.8172 71.7167 20.6703 79.5864 23.9302C87.456 27.1902 94.1823 32.7105 98.9145 39.7932C103.647 46.8759 106.172 55.2028 106.172 63.721C106.159 75.1393 101.618 86.0862 93.5435 94.1601C85.4694 102.234 74.5223 106.775 63.104 106.788ZM41.6858 90.2297L42.2579 90.6726C48.2146 95.3108 55.5546 97.8176 63.104 97.792C72.1374 97.7825 80.7981 94.1899 87.1858 87.8024C93.5736 81.4149 97.1665 72.7544 97.1763 63.721C97.2047 56.0932 94.6457 48.6812 89.9174 42.6957L89.4707 42.1261L41.6858 90.2297ZM63.104 29.6499C56.7635 29.6505 50.5488 31.4202 45.1592 34.76C39.7696 38.0998 35.4187 42.8772 32.5961 48.5548C29.7734 54.2325 28.591 60.585 29.1817 66.898C29.7724 73.211 32.1129 79.2339 35.9398 84.2893L36.3827 84.8729L84.352 37.0739L83.6058 36.5069C77.7079 32.0364 70.5047 29.6273 63.104 29.6499Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
